import homeHero from "./home_hero.png";
import homeCards from "./home_cards.png";
import feature from "./feature.png";
import expo from "./expo.png";
import expo02 from "./expo02.png";
import javascript from "./javascript.png";
import react from "./react.png";
import scene from "./scene.png";
import mockup from "./mockup.png";
import nodejs from "./node-js-svgrepo-com.svg";
import ts from "./typescript-svgrepo-com.svg";
import postman from "./postman-icon-svgrepo-com.svg";
import close from "./close.svg";
import logo from "./logo.svg";
import menu from "./menu.svg";
import user from "./user.png";
import Admin_Panel from "./Admin-Panel.png"
import Commercil_Web from "./Commercil-Web.png"
import Hoobank from "./Hoobank.png"
import react_machine from './react-drum-machine.png'
import youtube_web from "./youtube-web.png"
import hand_icon from "./hand-wave.png"

export default {
  homeHero,
  hand_icon,
  user,
  Admin_Panel,
  Commercil_Web,
  Hoobank,
  react_machine,
  youtube_web,
  homeCards,
  feature,
  expo,
  expo02,
  javascript,
  nodejs,
  postman,
  ts,
  react,
  scene,
  mockup,
  close,
  menu,
  logo,
};
